import MApp from "../MApp";
import MCaloricCalculator from "./MCaloricCalculator";

export default class MFrontCaloricCalculator extends MCaloricCalculator
{
	static selector = () => `.b-caloric-calculator--front`;

	static initialize()
	{
		document.querySelectorAll(this.selector()).forEach(el => {
			const caloricCalculator = new this(el);
		});

		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener('submit', event => {
			if (event.target.matches(this.selector())) {
				event.preventDefault();

				const caloricCalculator = new this(event.target.closest(this.selector()));
				caloricCalculator.getResult();
			}
		});

		document.addEventListener('click', event => {
			const selector = `${this.selector()} [type="submit"]`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();

				const caloricCalculator = new this(event.target.closest(this.selector()));
				caloricCalculator.getResult();
			}
		});

		document.addEventListener('click', event => {
			const selector = `${this.selector()} .caloric-calculator__recalculate-button`;
			if (event.target.matches(selector)) {
				event.preventDefault();

				const caloricCalculator = new this(event.target.closest(this.selector()));
				caloricCalculator.showInput();
			}
		});
	}

	setResponse(response)
	{
		MApp.setUrl(response.data.session.url);

		for (let metric of response.data.calculator.output.metrics) {
			this.setOutputMetric(metric);
		}

		this.hideInput();
		this.showOutput();
		this.scrollToTop();

		// for (let j in response.data.output.messages) {
		// 	form.caloricCalculatorAddOutputMessage(response.data.output.messages[j].message);
		// }

		// window.OneSignal = window.OneSignal || [];
		// window.OneSignal.push(function() {
		// 	window.OneSignal.sendTags({
		// 		segment: "caloricCalculator",
		// 		reference: form.attr('data-reference'),
		// 	});
		// });
	}
}
